<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)" style="cursor: pointer">close</mat-icon>
  </div>
  <div class="content" *ngIf="!isReportType">
    <h3>Select Report Type</h3>

    <mat-radio-group [(ngModel)]="selectedReportType">
      <mat-radio-button value="csv">CSV Report</mat-radio-button>
      <mat-radio-button value="summary">Single Page Summary</mat-radio-button>
    </mat-radio-group>

    <div class="submitBtn">
      <button class="btn btn-light hover-clear clear" (click)="onSubmit(true)">
        Submit
      </button>
    </div>
  </div>

  <div class="content" *ngIf="isReportType && !istable">
    <h3>Enter Report Details</h3>
    <form #reportForm="ngForm">
      <!-- Row 1: Vessel Name & IMO -->
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="vesselName">Vessel Name</label>
          <input
            type="text"
            class="form-control"
            name="vessel_name"
            [(ngModel)]="formData.vessel_name"
          />
        </div>
        <div class="col-md-6">
          <label class="imo">IMO</label>
          <input
            type="text"
            class="form-control"
            name="imo"
            [(ngModel)]="formData.imo"
          />
        </div>
      </div>

      <!-- Row 2: From Date & To Date -->
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="from">From Date</label>
          <input
            type="date"
            class="form-control"
            name="from_date"
            [(ngModel)]="formData.from_date"
          />
        </div>
        <div class="col-md-6">
          <label class="to">To Date</label>
          <input
            type="date"
            class="form-control"
            name="to_date"
            [(ngModel)]="formData.to_date"
          />
        </div>
      </div>

      <!-- Row 3: Client & Meraki PIC -->
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="client">Client</label>
          <select
            class="form-control"
            name="client"
            [(ngModel)]="formData.client"
          >
            <option *ngFor="let c of clients" [value]="c">{{ c }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="pic">Meraki PIC</label>
          <select
            class="form-control"
            name="meraki_pic"
            [(ngModel)]="formData.meraki_pic"
          >
            <option *ngFor="let p of merakiPics" [value]="p.value">
              {{ p.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Row 4: MGO & Type Periodic -->
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="mgo">MGO</label>
          <input
            type="text"
            class="form-control"
            name="mgo"
            [(ngModel)]="formData.mgo"
          />
        </div>
        <div class="col-md-6">
          <label class="reportType">Type Periodic</label>
          <select
            class="form-control"
            name="type_periodic"
            [(ngModel)]="formData.type_periodic"
          >
            <option *ngFor="let t of typePeriodicOptions" [value]="t">
              {{ t }}
            </option>
          </select>
        </div>
      </div>

      <div class="submitBtn mt-3">
        <button
          class="btn btn-light hover-clear clear"
          (click)="submitReport()"
        >
          Next
        </button>
      </div>
    </form>
  </div>
  <div class="content" *ngIf="isReportType && istable">
    <div class="table-container">
      <table class="dark-table">
        <thead>
          <tr>
            <th>Select</th>
            <!-- <th>Leg ID</th> -->
            <th>Departure Port</th>
            <th>Arrival Port</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>CP Speed</th>
            <th>CP Consumption</th>
            <th>Vessel Condition</th>
            <th>GW Time Gain/Loss</th>
            <th>Overall Time Gain/Loss</th>
            <th>GW Fuel Gain/Loss</th>
            <th>Total Fuel Gain/Loss</th>
            <th>GW Fuel Type</th>
            <th>Total Fuel Type</th>
            <th>Warranted</th>
            <th>Cp Ordered Cons GO</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let leg of tableData">
            <td>
              <input
                type="checkbox"
                [checked]="leg.checked"
                (change)="toggleRowSelection(leg, $event)"
              />
            </td>
            <!-- <td>{{ leg.legid }}</td> -->
            <td>{{ leg.fromloc }}</td>
            <td>{{ leg.toloc }}</td>
            <td>{{ leg.fromloctime }}</td>
            <td>{{ leg.toloctime }}</td>
            <td>{{ leg.cp_speed.toFixed(2) }}</td>
            <td>{{ leg.cp_consumption.toFixed(2) }}</td>
            <td>{{ leg.voyage_type }}</td>
            <td>{{ leg.gw_time.toFixed(2) }}</td>
            <td>{{ leg.total_time.toFixed(2) }}</td>
            <td>{{ leg.gw_fuel.toFixed(2) }}</td>
            <td>{{ leg.total_fuel.toFixed(2) }}</td>

            <!-- Editable Dropdowns -->
            <td>
              <select
                class="form-control tableDropdown"
                [(ngModel)]="leg.gw_fuel_type_used"
                (change)="onRowChange(leg)"
              >
                <option>HSFO</option>
                <option>LSFO</option>
                <option>MGO</option>
              </select>
            </td>
            <td>
              <select
                class="form-control tableDropdown"
                [(ngModel)]="leg.overall_fuel_type_used"
                (change)="onRowChange(leg)"
              >
                <option>HSFO</option>
                <option>LSFO</option>
                <option>MGO</option>
              </select>
            </td>
            <td>
              <select
                class="form-control tableDropdown"
                [(ngModel)]="leg.warranted_leg"
                (change)="onRowChange(leg)"
              >
                <option>YES</option>
                <option>NO</option>
              </select>
            </td>
            <td>
              <input
                class="form-control tableDropdown"
                type="text"
                [(ngModel)]="leg.cp_ord_con_go"
                (change)="onRowChange(leg)"
              />
            </td>
            <td>
              <mat-icon
                *ngIf="leg.rowChanged"
                class="udateIcon"
                (click)="updateRow(leg)"
              >
                save
              </mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-right submitbtn">
      <button class="btn btn-light hover-clear clear" (click)="submitClick()">
        Submit
      </button>
    </div>
  </div>
</div>
